import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=0a0feba2&scoped=true&"
import script from "./NotificationView.vue?vue&type=script&lang=js&"
export * from "./NotificationView.vue?vue&type=script&lang=js&"
import style0 from "./NotificationView.vue?vue&type=style&index=0&id=0a0feba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0feba2",
  null
  
)

export default component.exports